import { render } from "./PictureSticker.vue?vue&type=template&id=ff533350&scoped=true"
import script from "./PictureSticker.vue?vue&type=script&lang=js"
export * from "./PictureSticker.vue?vue&type=script&lang=js"

import "./PictureSticker.vue?vue&type=style&index=0&id=ff533350&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff533350"]])

export default __exports__